export { DeleteNote as DeleteNoteButton } from './DeleteNote';
